import { render, staticRenderFns } from "./privacy-agreement.vue?vue&type=template&id=09b52d74&scoped=true"
import script from "./privacy-agreement.vue?vue&type=script&lang=ts"
export * from "./privacy-agreement.vue?vue&type=script&lang=ts"
import style0 from "./privacy-agreement.vue?vue&type=style&index=0&id=09b52d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b52d74",
  null
  
)

export default component.exports